import React from 'react';
import { CheckCircle, Heart, Users, Book } from 'lucide-react';

const ImNew = () => {
  return (
    <div className="page-container im-new-page">
      {/* Hero Section */}
      <section className="page-hero">
        <div 
          className="page-hero-bg" 
          style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1511632765486-a01980e01a18?w=1920)' }}
        >
          <div className="page-hero-overlay" />
        </div>
        <div className="page-hero-content">
          <h1 className="page-hero-title">Welcome to United Christian Fellowship</h1>
          <p className="page-hero-subtitle">
            We're honored to have you. Whether you are visiting for the first time or exploring faith, 
            you belong here.
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="content-section">
        <div className="container">
          <div className="intro-text">
            <p>
              United Christian Fellowship is a community rooted in unity, worship, and spiritual growth. 
              We bring together believers from different churches and backgrounds to experience God's 
              presence and grow in faith together.
            </p>
          </div>

          {/* What We Believe */}
          <div className="info-card">
            <div className="info-icon">
              <Book size={32} />
            </div>
            <h2 className="info-title">What We Believe</h2>
            <div className="belief-list">
              <div className="belief-item">
                <CheckCircle size={20} className="belief-icon" />
                <p><strong>The Bible</strong> - We believe the Bible is God's inspired Word and our foundation for faith and life.</p>
              </div>
              <div className="belief-item">
                <CheckCircle size={20} className="belief-icon" />
                <p><strong>Jesus Christ</strong> - We believe in Jesus Christ as our Lord and Savior, who died and rose again for our salvation.</p>
              </div>
              <div className="belief-item">
                <CheckCircle size={20} className="belief-icon" />
                <p><strong>Unity in the Body</strong> - We believe all believers are one in Christ, transcending denominational boundaries.</p>
              </div>
              <div className="belief-item">
                <CheckCircle size={20} className="belief-icon" />
                <p><strong>The Holy Spirit</strong> - We believe in the power and presence of the Holy Spirit to transform lives.</p>
              </div>
              <div className="belief-item">
                <CheckCircle size={20} className="belief-icon" />
                <p><strong>Worship & Fellowship</strong> - We believe in the power of corporate worship and authentic community.</p>
              </div>
            </div>
          </div>

          {/* What to Expect */}
          <div className="info-card">
            <div className="info-icon">
              <Users size={32} />
            </div>
            <h2 className="info-title">What to Expect</h2>
            <p className="info-text">
              When you join us, you can expect a warm welcome, powerful worship, relevant teaching from God's Word, 
              and genuine fellowship. We create an atmosphere where everyone can encounter God's presence, regardless 
              of where you are in your spiritual journey.
            </p>
            <ul className="expectation-list">
              <li>Passionate worship that connects you with God</li>
              <li>Biblical teaching that's practical and relevant</li>
              <li>Friendly community that accepts you as you are</li>
              <li>Opportunities to serve and grow in your faith</li>
              <li>Prayer support when you need it most</li>
            </ul>
          </div>

          {/* How to Get Involved */}
          <div className="info-card">
            <div className="info-icon">
              <Heart size={32} />
            </div>
            <h2 className="info-title">How to Get Involved</h2>
            <p className="info-text">
              There are many ways to connect and grow with us:
            </p>
            <div className="involvement-grid">
              <div className="involvement-card">
                <h4>Attend Our Events</h4>
                <p>Join us for worship services, conferences, and special gatherings throughout the year.</p>
              </div>
              <div className="involvement-card">
                <h4>Connect in Community</h4>
                <p>Build meaningful relationships through small groups and fellowship activities.</p>
              </div>
              <div className="involvement-card">
                <h4>Serve Together</h4>
                <p>Use your gifts and talents to serve in various ministry areas.</p>
              </div>
              <div className="involvement-card">
                <h4>Grow Spiritually</h4>
                <p>Participate in Bible studies, prayer meetings, and discipleship opportunities.</p>
              </div>
            </div>
          </div>

          {/* Next Steps */}
          <div className="next-steps-section">
            <h2 className="section-title">Your Next Steps</h2>
            <div className="steps-grid">
              <div className="step-card">
                <div className="step-number">1</div>
                <h4>Watch Live</h4>
                <p>Experience a service online from the comfort of your home.</p>
              </div>
              <div className="step-card">
                <div className="step-number">2</div>
                <h4>Contact Us</h4>
                <p>Reach out with any questions or to learn more about our community.</p>
              </div>
              <div className="step-card">
                <div className="step-number">3</div>
                <h4>Join an Event</h4>
                <p>Attend one of our upcoming events to meet our community in person.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ImNew;
